export const TwentyFive = 'H';